module.exports = __webpack_public_path__ + "img/Lynch_CRES_PEG.3918fefb.svg";